import React, { useState } from 'react'
import {
  PlanBoxPlanName,
  PlanBoxStyled,
  PlanBoxSeparator,
  PlanBoxBestForAgencies,
  PlanBoxPlanNameWrapper,
} from 'Features/pricing/components/PlanBox/PlanBox.styled'

import { useTranslation } from 'react-i18next'

import { CePlans } from 'Features/pricing/components/PlanBox/CePlans'
import { EnterprisePlan } from 'Features/pricing/components/PlanBox/EnterprisePlan'
import { PlansJson } from 'Types/Plan'
import { Plan } from 'Features/pricing/types/Plan'
import { ProductTypes } from 'Types/ProductTypes'
import { PLAN_TYPES, PlanTypes } from 'Types/PlansTypes'
import { PlanBoxFeatures } from 'Features/pricing/components/PlanBox/PlanBoxFeatures'
import { CurrenciesTypes } from 'Types/Currencies'
import { ScheduleCallModal } from 'Features/ScheduleCallModal/ScheduleCallModal'
import {
  useFrontEndEventTrackingService,
  useResponsive,
} from '@clickcease/cc-client-components-lib'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { LANGUAGES_OPTIONS } from 'Types/Languages'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { useSwiper } from 'swiper/react'

type PlanBoxProps = {
  key?: string
  planName: PlanTypes
  numOfVisits: number
  onClick?: (openModal: boolean) => void
  plansJson: PlansJson
  plansDb: Array<Plan>
  bundle?: boolean
  crossSell?: boolean
  disableButton?: boolean
  currency: CurrenciesTypes
  productName: ProductTypes
  selectedPlan?: PlanTypes
  reactivation?: boolean
  isFirst?: boolean
  isLast?: boolean
  source: string
}

export const PlanBox = ({
  planName,
  numOfVisits,
  onClick,
  plansJson,
  plansDb,
  bundle,
  crossSell,
  currency,
  productName,
  selectedPlan,
  disableButton,
  isFirst,
  isLast,
  reactivation,
  source,
}: PlanBoxProps) => {
  const { t } = useTranslation('pricing')
  const { track } = useFrontEndEventTrackingService()
  const [modalToShow, setModalToShow] = useState<boolean>(false)
  const { language, setSignUp } = useUserStore()
  const swiper = useSwiper()
  const { isMobile } = useResponsive()

  const handleClick = () => {
    if (onClick) {
      setSignUp(false)
      if (!bundle && !crossSell && enterpriseOrMaxYearlyVisits) {
        setModalToShow(true)
        track(['dataLayer'], 'schedule a call', {})
      } else {
        onClick(enterpriseOrMaxYearlyVisits)
      }
    }
  }

  const enterpriseOrMaxYearlyVisits =
    planName === PLAN_TYPES.ENTERPRISE || numOfVisits > plansJson.max_yearly_visits

  return (
    <>
      <PlanBoxStyled
        bundle={bundle}
        crossSell={crossSell}
        pointerCursor={bundle || crossSell}
        setBorder={selectedPlan === planName}
        onClick={bundle || crossSell ? handleClick : () => {}}
      >
        {planName === PLAN_TYPES.ADVANCED && !isMobile && (
          <PlanBoxBestForAgencies es={language === LANGUAGES_OPTIONS.ES}>
            {t('best_for_agencies')}
          </PlanBoxBestForAgencies>
        )}
        <PlanBoxPlanNameWrapper>
          {isMobile && !isFirst ? (
            <FontAwesomeIcon
              icon={faAngleLeft as IconProp}
              style={{ height: '20px', color: 'var(--colors-primaryColor)' }}
              onClick={() => swiper.slidePrev()}
            />
          ) : (
            <div style={{ width: '20px' }} />
          )}
          <PlanBoxPlanName>{t(`${plansJson[planName].title}`)}</PlanBoxPlanName>
          {isMobile && !isLast ? (
            <FontAwesomeIcon
              icon={faAngleRight as IconProp}
              style={{ height: '20px', color: 'var(--colors-primaryColor)' }}
              onClick={() => swiper.slideNext()}
            />
          ) : (
            <div style={{ width: '20px' }} />
          )}
        </PlanBoxPlanNameWrapper>
        {planName === PLAN_TYPES.ENTERPRISE ? (
          <EnterprisePlan bundle={bundle} crossSell={crossSell} handleClick={handleClick} />
        ) : (
          <CePlans
            reactivation={reactivation}
            numOfVisits={numOfVisits}
            planName={planName}
            plansJson={plansJson}
            currency={currency}
            plansDb={plansDb}
            product={productName}
            bundle={bundle}
            crossSell={crossSell}
            handleClick={handleClick}
            enterpriseOrMaxYearlyVisits={enterpriseOrMaxYearlyVisits}
            disableButton={disableButton}
          />
        )}
        <PlanBoxSeparator />
        <PlanBoxFeatures plansJson={plansJson} planName={planName} crossSell={crossSell} />
      </PlanBoxStyled>
      <ScheduleCallModal
        onOpenChange={() => setModalToShow(false)}
        isOpen={modalToShow}
        source={source}
      />
    </>
  )
}
